import React from 'react';
import PropTypes from 'prop-types';
import Field from './field';
import FieldSetup from './field-setup';
import classNames from 'classnames';
import { ButtonGroup, Button, Panel } from 'react-bootstrap';

const copy = j => JSON.parse(JSON.stringify(j));

class FieldList extends React.Component {
  constructor(props) {
    super(props);
    this.handleSaveField = this.handleSaveField.bind(this);
    this.handleSelectField = this.handleSelectField.bind(this);
  }
  componentWillUpdate(nextProps, nextState) {
    if(this.props.fields.length != nextProps.fields.length) {
      if(this.props.onSelectField) {
        this.props.onSelectField(-1);
      }
    }
  }
  handleSaveField(field) {
    this.props.onUpdateField(field);
  }
  handleSelectField(event, id) {
    if(typeof this.props.onSelectField === 'function') {
      this.props.onSelectField(id);
    }
  }
  getFinalGroupOrder (groups = [], groupOrder = []) {
    const finalOrder = [];
    groupOrder.forEach(groupItem => {
      if(groups.indexOf(groupItem) > -1) {
        finalOrder.push(groupItem);
      }
    });
    groups.forEach(groupItem => {
      if(finalOrder.indexOf(groupItem) == -1) {
        finalOrder.push(groupItem);
      }
    });
    return finalOrder;
  }
  moveGroupUp(groupHeadings, idx) {
    if(idx == 0) {
      return [...groupHeadings];
    }
    const final = [];
    const before = groupHeadings.slice(0, idx - 1);
    const after = groupHeadings.slice(idx + 1, groupHeadings.length);
    const item = groupHeadings[idx - 1]
    const moving = groupHeadings[idx];
    return [...before, ...(moving ? [moving] : []), ...(item ? [item] : []), ...after];
  }
  moveGroupDown(groupHeadings, idx) {
    if(idx == groupHeadings.length) {
      return [...groupHeadings];
    }
    const final = [];
    const before = groupHeadings.slice(0, idx);
    const after = groupHeadings.slice(idx + 2, groupHeadings.length);
    const item = groupHeadings[idx + 1]
    const moving = groupHeadings[idx];
    return [...before, ...(item? [item] : []), ...(moving ? [moving] : []), ...after];
  }
  render() {
    let { fields, groupHeadings, groupOrder } = this.props;
    fields = fields ? fields : []; //Do some gymnastics to make sure we don't ever throw an error if fields are not provided.
    groupHeadings = typeof groupHeadings === 'undefined'? true : groupHeadings;
    let groups = {};
    for(let i = 0; i < fields.length; i++) {
      let field = fields[i];
      let name = field.group || '__none__';
      groups[name] = [...(groups[name] || []), field];
    }
    let zIndex = fields.length;

    let finalGroupOrder = this.getFinalGroupOrder(Object.getOwnPropertyNames(groups), groupOrder);

    return <div className="field-list">
      <div className="row">

        <div ref={ref => this.fields = ref} className={classNames({
          'col-xs-12' : true,
        })}>
          <div className="field-list-container">
            {finalGroupOrder.map((name, propIdx) =>  {
              const renderedFields = groups[name].sort((a,b) => a.order >= b.order ? 1 : -1).map((field, idx) => {
                const fieldClassName = `field col-xs-12 col-md-${field.flex}`;
                // if(!field._id || field._id != this.props.selected) {
                let value;
                if(this.props.entity) {
                  value = copy(this.props.entity);
                  let names = field.name.split('.');
                  while(names.length > 0) {
                    let name = names.shift();
                    if(names.length > 1 && !value[name]) {
                      value[name] = {}
                    }
                    value = value[name];
                  }
                }
                const canBeEdited = this.props.editAdminFields ? true : field.account ? true: false;
                return (
                  <div key={idx} className={fieldClassName} style={{opacity: this.props.editMode && !canBeEdited? 0.3: 1, order : field.order, minWidth : field.minWidth || undefined, zIndex: zIndex-- }}>
                    {this.props.disabled ? (<div className="pull-right mr-sm mt-sm"><i className="fa fa-cog"></i></div>) : ''}
                    <div className={`field${field._id && field._id == this.props.selected ? ' well bg-primary' : ''}`} style={{cursor : 'pointer'}} onClick={e => this.props.editMode && canBeEdited? this.handleSelectField(e,field._id) : null}>
                      <Field {...field} disabled={this.props.editMode? true: this.props.disabled} returnSelectValueAsObject={this.props.returnSelectValueAsObject} readOnly={this.props.readOnly} value={this.props.entity ? (value) : ''} onChange={value => this.props.onChange(value, field.name)} />
                    </div>
                  </div>
                )
                // }
              });

              return (
                <div key={`${name}-${propIdx}`} className="row">
                  {!this.props.hidePanel ? (
                    <Panel bsStyle='default' className="mb-none" header={groupHeadings ? (
                      <div>
                        {this.props.onUpdateGroupOrder ? <ButtonGroup className="pull-right mt-none">
                          {propIdx != 0 ? <Button onClick={e => this.props.onUpdateGroupOrder(this.moveGroupUp(finalGroupOrder, propIdx))}><i className="fa fa-arrow-up"></i></Button> : null}
                          {propIdx != finalGroupOrder.length - 1 ? <Button onClick={e => this.props.onUpdateGroupOrder(this.moveGroupDown(finalGroupOrder, propIdx))}><i className="fa fa-arrow-down"></i></Button> : null}
                        </ButtonGroup> : null}
                        <h3 className="panel-title clearfix">{name != '__none__'? name: 'Details'}</h3>
                      </div>
                    ) : ''}>
                      {renderedFields}
                    </Panel>
                  ) : renderedFields}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  }
}

FieldList.propTypes = {
  entity : PropTypes.object,
  fields : PropTypes.array.isRequired,
  groupHeadings: PropTypes.bool,
  hidePanel: PropTypes.bool,
  groupOrder: PropTypes.arrayOf(PropTypes.string),
  //Field Edit Mode
  editMode: PropTypes.bool,
  editAdminFields: PropTypes.bool,
  selected : PropTypes.string,
  disabled : PropTypes.bool,
  readOnly : PropTypes.bool,
  returnSelectValueAsObject: PropTypes.bool,
  onSelectField : PropTypes.func,
  onUpdateField : PropTypes.func,
  onDeleteField : PropTypes.func,
  onChangeField : PropTypes.func,
  onUpdateField : PropTypes.func,
  //Entity Mode
  onChange : PropTypes.func,
}

export default FieldList;



// WEBPACK FOOTER //
// ./src/browser/components/form-builder/field-list.js